import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";
import { UiArguments } from "@recore-solutions/nstar-lib";

@Injectable({ providedIn: "root" })
export class CountyFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (
		uiArguments: UiArguments
	): ((term: any, additionalParams?: any[]) => HttpParams | null) => {
		const component = this.getPrimaryComponent(uiArguments);
		const children = this.getChildrenFromUiArguments(uiArguments);

		const dependent = children.map(this.getDependentOf(uiArguments)).filter((u) => !!u);
		const control = uiArguments.formGroup?.getColumnByUiComponent(dependent[0], uiArguments.keys);

		return (term: any) => {
			const nameAndValuePairs: { [name: string]: any } = {};
			if (!term || typeof term === "string") {
				const value = control.value?.key
					? control.value.key
					: control.value.toJSON
					? control.value.toJSON()
					: control.value;

				nameAndValuePairs[component.databaseColumn] = `${("0" + value).slice(-2)}%`;
			}

			return this.getHttpParamsFromNameAndValuePairs(nameAndValuePairs);
		};
	};

	searchFn = () => (httpParams: HttpParams) => {
		if (!httpParams) {
			return of([]);
		}
		return this.listingService.getGenericProcValues("Polaris.spGetCounty", httpParams);
	};
}
